import { MatchEventType } from 'shared/types/match-event';
import { HighlightWindow, HighlightWindowSettings } from 'modules/video-markers/domain/interfaces';

/**
 * Окна подобраны замером на записях прогона (`.claude/docs/video-markers.md`, «Position accuracy»).
 * Позиция по хронометражу — это момент **ввода** события, а не сам момент: статист отстаёт на 0 с
 * (вносит гол, глядя на линию) … 9 с (типичный ввод после повтора) у голов и до 19 с у фолов,
 * карточек и сейвов. Поэтому запас «до» покрывает худшее опоздание, а «после» — празднование при
 * нулевом.
 *
 * Хвост гола держит ещё и плашку табло событий трансляции — она вшита в запись и служит титром
 * гола. Плашка появляется через ~1,5 с после позиции ввода и живёт `duration` табло (`use-load-event.ts`),
 * на прогоне ~8 с. При хвосте +8 с её конец обрезался на ~1,5 с (эфир VK, 09.10.2026).
 */
const GOAL_WINDOW: HighlightWindow = { beforeMs: 20_000, afterMs: 12_000 };

/** Голы, которые идут в счёт матча. Серия пенальти — отдельный счёт, её удары сюда не входят. */
export const HIGHLIGHT_GOAL_EVENT_TYPES: readonly MatchEventType[] = ['GOAL', 'PASS_AND_GOAL', 'PENALTY_GOAL', 'OWN_GOAL'];

/** События без картинки: смотреть в клипе нечего. */
export const HIGHLIGHT_SKIPPED_EVENT_TYPES: readonly MatchEventType[] = ['REPLACEMENT', 'TIME_OUT'];

export const DEFAULT_HIGHLIGHT_WINDOWS: HighlightWindowSettings = {
  byEventType: Object.fromEntries(HIGHLIGHT_GOAL_EVENT_TYPES.map((type) => [type, GOAL_WINDOW])),
  // Оператор жмёт ⭐, уже увидев момент (как метка Veo), но на прогоне — через 8–14 с после него.
  manual: { beforeMs: 20_000, afterMs: 5_000 },
  // Фол, карточка, сейв вносятся позже голов (сейв — после пенальти, на 19 с позже момента).
  fallback: { beforeMs: 20_000, afterMs: 5_000 },
  mergeGapMs: 3_000,
};
